import React from 'react';
import { SummaryWidget } from '@reviewshake-app/shake-ui';
import { ReviewWidget } from '../../types';

type Props = {
  children: any;
  data: ReviewWidget;
};

const SummaryContainer = ({ children, data }: Props) => {
  const { averageRating, count, reviewSources } = data?.reviewSummary || {};

  const logos = reviewSources?.reduce((acc, current) => [...acc, current.sourcePic], []) || [];

  return (
    <div className="v2-widget-summary-container" style={{ paddingBottom: '1px' }}>
      {data && (data.displayMode === 'SUMMARY_REVIEW' || data.displayMode === 'SUMMARY') && (
        <SummaryWidget
          rating={averageRating}
          reviewsCount={count}
          logos={logos}
          locale={data.locale}
          brandingLogo={data.brandingLogo}
          brandingName={data.brandingName}
        />
      )}
      {data.displayMode !== 'SUMMARY' && children}
    </div>
  );
};

export default SummaryContainer;
